"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _MobileHeader = _interopRequireDefault(require("../MobileHeader"));

var _Desktop = _interopRequireDefault(require("./Desktop"));

var _Logo = _interopRequireDefault(require("./Logo"));

var _Mobile = _interopRequireDefault(require("./Mobile"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  return {
    root: {
      zIndex: 10,
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%'
    }
  };
};

var ResponsiveHeader = function ResponsiveHeader(props) {
  var LogoProps = props.LogoProps,
      className = props.className,
      style = props.style,
      children = props.children;
  var classes = useStyles();
  return (0, _core.jsx)(_MobileHeader.default, {
    css: classes.root,
    className: className,
    style: style
  }, (0, _core.jsx)(_Logo.default, LogoProps), (0, _core.jsx)(_Mobile.default, {
    LogoProps: LogoProps
  }, children), (0, _core.jsx)(_Desktop.default, null, children));
};

__signature__(ResponsiveHeader, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = ResponsiveHeader;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/index.tsx");
  reactHotLoader.register(ResponsiveHeader, "ResponsiveHeader", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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